import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AdminMessaging({ user }) {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [newNotification, setNewNotification] = useState({
    user_id: '',
    notification_type: 'performance_alert',
    title: '',
    message: '',
    link: ''
  });

  const [broadcastNotification, setBroadcastNotification] = useState({
    notification_type: 'performance_alert',
    title: '',
    message: '',
    link: ''
  });

  useEffect(() => {
    fetchDrivers();
  }, []);

  const fetchDrivers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/drivers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDrivers(response.data);
    } catch (error) {
      console.error('Erreur drivers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotification = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/notifications', {
        ...newNotification,
        user_type: 'driver'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('Notification envoyée avec succès!');
      setNewNotification({
        user_id: '',
        notification_type: 'performance_alert',
        title: '',
        message: '',
        link: ''
      });
    } catch (error) {
      console.error('Erreur envoi:', error);
      alert('Erreur lors de l\'envoi de la notification.');
    }
  };

  const handleBroadcast = async (e) => {
    e.preventDefault();
    if (!window.confirm(`Envoyer cette notification à tous les ${drivers.length} chauffeurs ?`)) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/notifications/broadcast', broadcastNotification, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert(`Notification envoyée à ${drivers.length} chauffeurs!`);
      setBroadcastNotification({
        notification_type: 'performance_alert',
        title: '',
        message: '',
        link: ''
      });
    } catch (error) {
      console.error('Erreur broadcast:', error);
      alert('Erreur lors de l\'envoi de la notification.');
    }
  };

  const notificationTypes = [
    { value: 'message', label: 'Message', color: '#B8472E' },
    { value: 'document_expiring', label: 'Document expirant', color: '#f39c12' },
    { value: 'incident_update', label: 'Mise à jour incident', color: '#e74c3c' },
    { value: 'payslip_available', label: 'Bulletin disponible', color: '#27ae60' },
    { value: 'badge_earned', label: 'Badge gagné', color: '#9b59b6' },
    { value: 'performance_alert', label: 'Alerte performance', color: '#e67e22' }
  ];

  if (loading) {
    return (
      <div className="container">
        <div className="loading">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <h2 style={{ marginBottom: '2rem' }}>Messagerie Chauffeurs</h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '2rem' }}>
          {/* Notification individuelle */}
          <div style={{ background: '#f8f9fa', padding: '2rem', borderRadius: '12px' }}>
            <h3 style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              Message individuel
            </h3>

            <form onSubmit={handleSendNotification}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Chauffeur
                </label>
                <select
                  value={newNotification.user_id}
                  onChange={(e) => setNewNotification({ ...newNotification, user_id: e.target.value })}
                  required
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                >
                  <option value="">Sélectionner un chauffeur</option>
                  {drivers.map(driver => (
                    <option key={driver.user_id} value={driver.user_id}>
                      {driver.firstname} {driver.lastname} ({driver.vehicle_plate || 'N/A'})
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Type de notification
                </label>
                <select
                  value={newNotification.notification_type}
                  onChange={(e) => setNewNotification({ ...newNotification, notification_type: e.target.value })}
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                >
                  {notificationTypes.map(type => (
                    <option key={type.value} value={type.value}>{type.label}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Titre
                </label>
                <input
                  type="text"
                  value={newNotification.title}
                  onChange={(e) => setNewNotification({ ...newNotification, title: e.target.value })}
                  required
                  placeholder="Ex: Action requise"
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Message
                </label>
                <textarea
                  value={newNotification.message}
                  onChange={(e) => setNewNotification({ ...newNotification, message: e.target.value })}
                  required
                  rows={4}
                  placeholder="Ex: Veuillez mettre à jour votre permis de conduire"
                  style={{
                    width: '100%',
                    padding: '0.7rem',
                    borderRadius: '6px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Lien (optionnel)
                </label>
                <input
                  type="text"
                  value={newNotification.link}
                  onChange={(e) => setNewNotification({ ...newNotification, link: e.target.value })}
                  placeholder="Ex: /documents"
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <button
                type="submit"
                style={{
                  width: '100%',
                  padding: '0.8rem',
                  background: '#B8472E',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '1rem'
                }}
              >
                Envoyer
              </button>
            </form>
          </div>

          {/* Notification broadcast */}
          <div style={{ background: '#fff3cd', padding: '2rem', borderRadius: '12px', border: '2px solid #B9831C' }}>
            <h3 style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              Message à tous les chauffeurs
            </h3>

            <div style={{
              background: '#fff',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1.5rem',
              border: '1px solid #B9831C'
            }}>
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.5rem' }}>
                {drivers.length} chauffeurs
              </div>
              <div style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666', marginTop: '0.3rem' }}>
                recevront ce message
              </div>
            </div>

            <form onSubmit={handleBroadcast}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Type de notification
                </label>
                <select
                  value={broadcastNotification.notification_type}
                  onChange={(e) => setBroadcastNotification({ ...broadcastNotification, notification_type: e.target.value })}
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                >
                  {notificationTypes.map(type => (
                    <option key={type.value} value={type.value}>{type.label}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Titre
                </label>
                <input
                  type="text"
                  value={broadcastNotification.title}
                  onChange={(e) => setBroadcastNotification({ ...broadcastNotification, title: e.target.value })}
                  required
                  placeholder="Ex: Réunion d'équipe"
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Message
                </label>
                <textarea
                  value={broadcastNotification.message}
                  onChange={(e) => setBroadcastNotification({ ...broadcastNotification, message: e.target.value })}
                  required
                  rows={4}
                  placeholder="Ex: Réunion obligatoire vendredi 10h au siège"
                  style={{
                    width: '100%',
                    padding: '0.7rem',
                    borderRadius: '6px',
                    border: '1px solid #ddd',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Lien (optionnel)
                </label>
                <input
                  type="text"
                  value={broadcastNotification.link}
                  onChange={(e) => setBroadcastNotification({ ...broadcastNotification, link: e.target.value })}
                  placeholder="Ex: /dashboard"
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <button
                type="submit"
                style={{
                  width: '100%',
                  padding: '0.8rem',
                  background: '#f39c12',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '1rem'
                }}
              >
                Envoyer à tous
              </button>
            </form>
          </div>
        </div>

        {/* Légende des types */}
        <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#f8f9fa', borderRadius: '12px' }}>
          <h4 style={{ marginBottom: '1rem' }}>Types de messages disponibles:</h4>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem' }}>
            {notificationTypes.map(type => (
              <div
                key={type.value}
                style={{
                  padding: '0.8rem',
                  background: 'white',
                  border: `2px solid ${type.color}`,
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                <div style={{
                  width: '12px',
                  height: '12px',
                  background: type.color,
                  borderRadius: '50%'
                }} />
                <span style={{ fontSize: '0.9rem' }}>{type.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Exemples d'utilisation */}
        <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#e3f2fd', borderRadius: '12px' }}>
          <h4 style={{ marginBottom: '1rem' }}>💡 Exemples d'utilisation:</h4>
          <ul style={{ paddingLeft: '1.5rem', lineHeight: '1.8' }}>
            <li><strong>Document expirant:</strong> Rappeler à un chauffeur de renouveler son permis</li>
            <li><strong>Mise à jour incident:</strong> Informer qu'un véhicule est réparé</li>
            <li><strong>Bulletin disponible:</strong> Notifier qu'un nouveau bulletin de paie est en ligne</li>
            <li><strong>Badge gagné:</strong> Féliciter pour un objectif atteint</li>
            <li><strong>Alerte performance:</strong> Signaler un problème de ponctualité</li>
            <li><strong>Broadcast:</strong> Annoncer une réunion, un changement de procédure, etc.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AdminMessaging;
